import * as React from 'react';
import { isEmpty } from 'lodash';

import { CLOUDINARY_CLOUD_NAME } from 'utils/cloudinary';

// https://cloudinary.com/documentation/video_manipulation_and_delivery#video_transformations_reference
type Props = {
  cloudName: string,
  publicId: string,
  controls?: boolean,
  withTransformation?: boolean,
  width: number,
  height: number,
  crop: 'scale' | 'fill' | 'fit' | 'limit' | 'pad' | 'lpad' | 'crop',
  gravity: 'north_west' | 'north' | 'north_east' | 'west' | 'center' | 'east' | 'south_west' | 'south' | 'south_east',
  quality: number
};

const DEFAULT_CLOUDINARY_VIDEO_TYPES = ['webm', 'mp4', 'ogv', 'mov'];

class CloudinaryVideo extends React.PureComponent<Props> {
  static defaultProps = {
    cloudName: CLOUDINARY_CLOUD_NAME,
    publicId: '',
    width: 200,
    height: 200,
    crop: 'lpad',
    gravity: 'center',
    quality: 100
  };

  getUrl(type: string): string {
    const {
      cloudName,
      publicId,
      withTransformation,
      width,
      height,
      crop,
      gravity,
      quality
    } = this.props;

    if (withTransformation) {
      return `https://res.cloudinary.com/${cloudName}/video/upload/q_auto,c_${crop},g_${gravity},h_${height},q_${quality},w_${width}/${publicId}.${type}`;
    }

    return `https://res.cloudinary.com/${cloudName}/video/upload/${publicId}.${type}`;
  }

  renderSources(): React.ReactNode {
    return DEFAULT_CLOUDINARY_VIDEO_TYPES.map((type) => (
      <source
        key={`video_type_${type}`}
        src={this.getUrl(type)}
        type={`video/${(type === 'ogv') ? 'ogg' : type}`}
      />
    ));
  }

  render(): React.ReactNode {
    const {
      publicId,
      controls
    } = this.props;

    if (isEmpty(publicId)) {
      return null;
    }

    return (
      // eslint-disable-next-line jsx-a11y/media-has-caption
      <video
        controls={controls}
        controlsList="nodownload"
      >
        {this.renderSources()}
      </video>
    );
  }
}

export default CloudinaryVideo;
